var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductionPlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82617 50.0226L30.343 24.0753L43.3043 34.4547L69.2244 11.1017",
    stroke: "#949494",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2925 11.0994H69.2245V16.0314",
    stroke: "#949494",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8828 60.4167H68.8148V55.4847",
    stroke: "#949494",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23291 14.7959L33.0579 44.3879L40.4559 36.9899L50.3199 46.8539L52.7859 44.3879L67.5819 59.1839",
    stroke: "#949494",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.048 67.815H1M2.233 0V69.0406V0Z",
    stroke: "#949494",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionPlot);
export default __webpack_public_path__ + "static/media/productionPlot.d5cc88e711fdd6606a53048814e37d48.svg";
export { ForwardRef as ReactComponent };